<template>
    <div class="p-4 bg-white rounded-10 overflow-hidden text-a-brown-502314">
        <div class="flex">
            <img class="ml-0 mr-2 my-auto" src="@/assets/icon/ic-pickup-brown.svg" />
            <div class="ml-0 mr-auto my-auto font-bold" >{{lbl.deliverymethod.pickup_at}}</div>
            <div class="ml-auto mr-0 my-auto text-14 text-a-red-d62300 cursor-pointer" 
                @click="clickSelectBranch()">
                {{lbl.deliverymethod.select_branch}}
            </div>
        </div>
        <div class="bg-a-egg-f5ebdc p-4 rounded-10 overflow-hidden mt-2">
            <div>
                <div class="font-bold text-14">{{getNameLocation()}}</div>
                <!-- <div>{{FilterNumberDecimalFormat(getKM(),1)}} Km</div> -->
            </div>
            <div class="text-14 text-a-brown-9f8273 pt-2">{{getWorkingDay()}}</div>
        </div>
        <div class="text-center text-12 mt-2 px-4">{{lbl.deliverymethod.if_you_change}}</div>
        <div class="grid grid-cols-2 gap-2 pt-5 cursor-pointer">
            <div class="flex border rounded-10 w-full p-2"
                @click="clickOrderPlan('TakeOut')"
                :class="{'border-a-brown-502314': pickup.orderPlan == 'TakeOut',
                        'border-a-brown-d7c7b8': pickup.orderPlan != 'TakeOut'}">
                <img class="h-6 ml-0 mr-2 my-auto" src="@/assets/icon/ic-takeaway-brown.svg" />
                <div class="text-14 ml-0 mr-auto my-auto">{{lbl.deliverymethod.takeaway}}</div>
                <img v-if="pickup.orderPlan == 'TakeOut'"
                    class="h-2.5 mr-0 ml-auto my-auto" src="@/assets/icon/ic-check-brown.svg" />
            </div>
            <div class="flex border rounded-10 w-full p-2"
                @click="clickOrderPlan('DineIn')"
                :class="{'border-a-brown-502314': pickup.orderPlan == 'DineIn',
                        'border-a-brown-d7c7b8': pickup.orderPlan!= 'DineIn'}">
                <img class="h-6 ml-0 mr-2 my-auto" src="@/assets/icon/ic-dinein-brown.svg" />
                <div class="text-14 ml-0 mr-auto my-auto">{{lbl.deliverymethod.dinein}}</div>
                <img v-if="pickup.orderPlan == 'DineIn'"
                    class="h-2.5 mr-0 ml-auto my-auto" src="@/assets/icon/ic-check-brown.svg" />
            </div>
        </div>
    </div>
</template>

<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "Pickup",
    mixins: [LocaleMixin],
    inject: ['DeliveryStore'],
    props: {
        delivery: { type: Object}
    },
    data: function() {
        return {
            pickup: {
                orderPlan: ""
            },
        };
    },
    created: function() {
        if (this.DeliveryStore.state.delivery.orderPlan) {
            this.pickup.orderPlan = this.DeliveryStore.state.delivery.orderPlan;
        } else {
            this.pickup.orderPlan = "TakeOut";
            this.DeliveryStore.state.delivery.orderPlan = "TakeOut"
        }
        console.log(this.delivery);
    },
    methods: {
        clickOrderPlan: function(orderPlan) {
            this.pickup.orderPlan = orderPlan;
            this.DeliveryStore.state.delivery.orderPlan = this.pickup.orderPlan;
        },
        getNameLocation: function() {
            if (this.delivery.location) {
                if (this.localeCode == 1033) 
                    return this.delivery.location.nameEN;
                else 
                    return this.delivery.location.name;
            } else {
                return "";
            }
        },
        getWorkingDay: function() {
            if (this.delivery.location) {
                if (this.localeCode == 1033) 
                    return this.delivery.location.pickupWorkingDayEn;
                else 
                    return this.delivery.location.pickupWorkingDay;
            } else {
                return "";
            }
        },
        getKM: function() {
            return this.delivery.location.distance / 1000;
        },
        clickSelectBranch: function() {
            this.$router.push('/selectbranch');
        }
    }

}
</script>

<style>

</style>